import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { v4 as uuid } from "uuid";

const getDynamicSx = (isMobile) => ({
  buttonSx: {
    width: "125px",
    height: "59px",
    color: "#000",
    opacity: "1",
    fontFamily: "Inter",
    fontSize: "24px",
    fontWeight: "600",
    borderRadius: "40px",
    padding: "0px",
    "&:hover": {
      background: "linear-gradient(180deg, rgba(255, 218, 11, 1.00) 0%, #FFB400 100%)",
    },
  },
  menuSx: {
    width: "auto",
    fontSize: "18px",
  },
});

const NAV_LIST = [
  {
    id: uuid(),
    label: "協會簡介",
    linkPrefix: "charity1",
    menuItemId: "charity1",
  },
  {
    id: uuid(),
    label: "最新消息",
    linkPrefix: "charity2",
    menuItemId: "charity2",
  },
  {
    id: uuid(),
    label: "活動紀錄",
    linkPrefix: "charity3",
    menuItemId: "charity3",
  },
  {
    id: uuid(),
    label: "我要捐款",
    linkPrefix: "charity4",
    menuItemId: "charity4",
  },
];

export default function NavbarCharity({ path = "", charityName = "" }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery("(max-width:1350px)");
  const [drawerWidth, setDrawerWidth] = useState("50%");
  const { buttonSx } = getDynamicSx(isMobile);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  let location = useLocation();

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);
    let id = searchParams.get("id");

    if (!id) {
      window.location.href = "/";
    }

    function updateDrawerWidth() {
      if (window.innerWidth < 768) {
        setDrawerWidth("75%");
      } else {
        setDrawerWidth("50%");
      }
    }

    window.addEventListener("resize", updateDrawerWidth);
    updateDrawerWidth(); // Initialize on first render

    return () => {
      window.removeEventListener("resize", updateDrawerWidth);
    };
  }, [path, charityName, location.search]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  return (
    <div className="nav">
      <div className="max-w-[1650px] mx-auto flex items-center justify-between px-[10px] h-[100px]">
        <div className="logo-warp">
          <h2 className="ml-28 text-[#ffffff] font-semibold text-5xl table:text-4xl mobile:text-4xl mobile:hidden">
            {charityName}
          </h2>
        </div>
        {isMobile ? (
          <>
            <IconButton
              edge="start"
              color="inherit"
              size="large"
              aria-label="menu"
              onClick={handleDrawerOpen}
            >
              <MenuIcon
                className="text-white"
                sx={{
                  fontSize: {
                    xs: "35px",
                    sm: "40px",
                  },
                }}
              />
            </IconButton>
            <Drawer
              anchor="right"
              open={isDrawerOpen}
              onClose={handleDrawerClose}
              disableScrollLock="true"
              PaperProps={{
                style: {
                  top: "100px",
                  width: drawerWidth,
                },
              }}
            >
              <div className="list-warp" onMouseLeave={handleDrawerClose}>
                {NAV_LIST.map((item) => (
                  <div key={item.id} style={{ padding: "10px 20px" }}>
                    <Link to={`/${item.linkPrefix}?id=${path}`} onClick={handleDrawerClose}>
                      <span className="list-btn">{item.label}</span>
                    </Link>
                  </div>
                ))}
              </div>
            </Drawer>
          </>
        ) : (
          <div className="list-warp">
            {NAV_LIST.map((item) => (
              <div key={item.id} onMouseOver={handleOpen}>
                <Button
                  sx={buttonSx}
                  id={`fade-button-${item.menuItemId}`}
                  aria-controls={`fade-menu-${item.menuItemId}`}
                  aria-haspopup="true"
                  aria-expanded={Boolean(anchorEl)}
                >
                  <Link to={`/${item.linkPrefix}?id=${path}`}>
                    <span className="list-btn">{item.label}</span>
                  </Link>
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

NavbarCharity.propTypes = {
  path: PropTypes.string,
  charityName: PropTypes.string,
};
